<template>
  <div class="product-template __donate __limited-edu  __limited-edu--custom2021 __uob-2025">
    <div class="container pd-sm-0">
      <div class="col-md-push-1 col-md-10">
        <h1 data-v-1f20e9ef="" class="text-center mb-20 flex justify-content-between align-items-center">
          <img src="/static/img/uob/logo-uob-heartbeat@2x.png" srcset="/static/img/uob/logo-uob-heartbeat@2x.png" width="130px" alt="TCFE x UOB" class="logo-heartbeat" />
          <img src="/static/img/uob/logo-uob-tcfe@2x.png" srcset="/static/img/uob/logo-uob-tcfe@2x.png" width="180px" alt="TCFE x UOB" class="logo" />
        </h1>
        <h2 class="product-custom-title text-center" v-html="product.meta.product_custom_title"></h2>
      </div>
    </div>

    <div class="container pd-sm-0">
      <div class="col-md-push-1 col-md-10">
        <div class="product product--inline">
          <div class="product__block--form ">
            <div class="radius block shadow ">
              <product-donate-choice
              :show-donate-type="true"
              :product="product"
              :custom="true"
              v-model="product.price"
              ref="donateChoice"
              classes="col-1-5" />

              <div class="form__wrapper mt-15 mb-15">

                <!-- Take Reward -->
                <div v-if="product.price" class="form__section">
                  <label class="" :class="{disable: isRewardDisabled}">
                    <strong>{{ rewardTitleText }}</strong> <br />
                    <span class="small">กรุณากรอกข้อมูลผู้ลงสมัครวิ่งและเลือกระยะทาง</span>

                  </label>

                  <transition name="slide-down">
                    <div class="slide-down-wrapper" :class="{disable: isRewardDisabled}">
                      <div class="form__section block-third slide-down-item">
                        <div
                          v-for="(reward, i) in rewards"
                          :key="i"
                          class="reward-item"
                          :class="{ 'reward-item-error': reward.error }"
                        >
                          <div class="d-flex align-items-center block-heading">
                            <div class="bib-section-title">ผู้สมัครวิ่งคนที่ {{ i+1 }}  </div>
                          </div>

                          <div>
                            <div class="row">
                              <div class="">
                                <div class="col-sm-12 col-lg-6">
                                  <div class="form__item--block">
                                    <div class="row d-flex align-items-center runner-form-row">
                                      <div class="col-sm-12 col-lg-4">
                                        <label class="form__label lh-1" :for="`name.${i}`">
                                          ชื่อ-สกุล<br /><small>แสดงบน BIB </small><span style="color: #EA2B2B;">*</span>
                                        </label>

                                      </div>
                                      <div class="col-sm-12 col-lg-8">
                                        <input
                                          v-model="reward.fullName"
                                          type="text"
                                          placeholder="ระบุชื่อเป็นภาษาอังกฤษเท่านั้น"
                                          class="form__text"
                                          :class="{ 'form__input--error': reward.errors.fullName }"
                                          :name="`name.${i}`"
                                          :id="`name.${i}`"
                                        />
                                        <div class="small" style="margin-top: -0.5rem; color: #EA2B2B;">** ระบุชื่อเป็นภาษาอังกฤษเท่านั้น</div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-12 col-lg-6">
                                  <div class="form__item--block">
                                    <div class="row d-flex align-items-center runner-form-row">
                                      <div class="col-sm-12 col-lg-4">
                                        <label class="form__label" :for="`tel.${i}`">
                                          เบอร์โทร <span style="color: #EA2B2B;">*</span>
                                        </label>
                                      </div>
                                      <div class="col-sm-12 col-lg-8">
                                        <input
                                          v-model="reward.tel"
                                          type="text"
                                          placeholder="0123456789"
                                          class="form__text"
                                          :class="{ 'form__input--error': reward.errors.tel }"
                                          :name="`tel.${i}`"
                                          :id="`tel.${i}`"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="">
                                <div class="col-sm-12 col-lg-6">
                                  <div class="form__item--block">
                                    <div class="row d-flex align-items-center runner-form-row">
                                      <div class="col-sm-12 col-lg-4">
                                        <label class="form__label" :for="`gender.${i}`">
                                          เพศ <span style="color: #EA2B2B;">*</span>
                                        </label>
                                      </div>
                                      <div class="col-sm-12 col-lg-8">
                                        <select
                                          v-model="reward.gender"
                                          type="text"
                                          class="form__select"
                                          :class="{ 'form__input--error': reward.errors.gender }"
                                          :name="`gender.${i}`"
                                          :id="`gender.${i}`"
                                        >
                                          <option
                                            v-for="gender in genders"
                                            :key="gender.value"
                                            :value="gender.value">
                                            {{ gender.name }}
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-sm-12 col-lg-6">
                                  <div class="form__item--block">
                                    <div class="row d-flex align-items-center runner-form-row">
                                      <div class="col-sm-12 col-lg-4">
                                        <label class="form__label" :for="`gender.${i}`">
                                          ระบุระยะทาง <span style="color: #EA2B2B;">*</span>
                                        </label>
                                      </div>
                                      <div class="col-sm-12 col-lg-8">
                                        <select
                                          v-model="reward.range"
                                          type="text"
                                          class="form__select"
                                          :class="{ 'form__input--error': reward.errors.range }"
                                          :name="`range.${i}`"
                                          :id="`range.${i}`"
                                        >
                                          <option
                                            v-for="range in ranges"
                                            :key="range.value"
                                            :value="range.value">
                                            {{ range.name }}
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">

                            </div>
                          </div>
                        </div>
                      </div> <!-- end form_section -->
                    </div>
                  </transition>
                  <div class="alert alert--error" v-if="error.atLeastOneReward" style="font-size: 16px; font-weight: bold;">กรุณากรอกข้อมูลผู้สมัครวิ่งอย่างน้อย 1 คน</div>
                </div>
              </div><!-- end form wrapper -->

              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <!-- ตำแหน่ง -->
                  <div class="pt-15">
                    <div><strong>ระบุตำแหน่ง <span style="color: #E82B27">*</span></strong></div>
                    <div class="form__select">
                      <!-- rewardConfigChoice (ตำแหน่ง) -->
                      <select v-model="attributes.info.rewardConfigChoice">
                        <option value="">-- โปรดระบุตำแหน่ง --</option>
                        <option
                          v-for="LevelOption in LevelOptions"
                          :key="LevelOption.text"
                          :value="LevelOption.description"
                        >
                          {{ LevelOption.description }}
                        </option>
                      </select>
                    </div>
                    <div class="alert alert--error" v-if="error.rewardConfigChoice">กรุณาระบุตำแหน่ง</div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <!-- หน่วยงาน -->
                  <div class="pt-15">
                    <div><strong>ระบุหน่วยงานของท่าน <span style="color: #E82B27">*</span></strong></div>
                    <div class="form__select">
                      <!-- rewardConfigText (หน่วยงาน) -->
                      <select v-model="attributes.info.rewardConfigText">
                        <option value="">-- โปรดระบุหน่วยงาน --</option>
                        <option
                          v-for="FunctionOption in FunctionOptions"
                          :key="FunctionOption.text"
                          :value="FunctionOption.description"
                        >
                          {{ FunctionOption.description }}
                        </option>
                      </select>
                    </div>
                    <div class="alert alert--error" v-if="error.rewardConfigText">กรุณาระบุหน่วยงานของท่าน</div>
                  </div>
                </div>
              </div>

              <div class="row">
                <!-- สถานที่รับเสื้อ -->
                <div class="col-sm-6 col-md-6">
                  <div><strong>ระบุสถานที่รับ เลขประจำตัวผู้ร่วมงาน (BIB) <span style="color: #E82B27">*</span></strong><br />
                    <span class="text-remark">พนักงานสาขาจัดส่งให้ที่สาขา โปรดระบุสาขาที่รับของท่านให้ถูกต้อง</span>
                  </div>
                  <div class="form__select">
                    <select v-model="attributes.info.pickupPoint">
                      <option value="">-- โปรดระบุสถานที่ --</option>
                      <option
                        v-for="PlaceOption in PlaceOptions"
                        :key="PlaceOption.name"
                        :value="PlaceOption.name"
                      >
                        {{ PlaceOption.name }}
                      </option>
                    </select>
                  </div>
                  <div class="alert alert--error" v-if="error.pickupPoint">กรุณาระบุสาขาที่รับของที่ระลึก</div>


                  <div v-if="isPlaceOptionType('select')">
                    <div v-if="selectedPlaceOption.params.optionTitle"><strong>{{ selectedPlaceOption.params.optionTitle }} <span style="color: #E82B27">*</span></strong></div>
                    <div class="form__select">
                      <select v-model="attributes.info.pickupDetail">
                        <option selected value="">-- {{ selectedPlaceOption.params.optionLabel }} --</option>
                        <option
                          v-for="item in selectedPlaceOption.params.optionType.items"
                          :key="item.name"
                          :value="item.name"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                    </div>
                    <div class="alert alert--error" v-if="error.pickupDetail">
                      <span v-if="selectedPlaceOption.params.required">{{ selectedPlaceOption.params.required }}</span>
                      <span v-else>กรุณากรอกข้อมูล</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 col-md-6">
                  <div class="">
                    <div v-if="isPlaceOptionType('text')" class="">
                      <label v-if="selectedPlaceOption.params.optionLabel" for="info_name2_text" class="form__label">
                        <strong>
                          {{ selectedPlaceOption.params.optionLabel }} <span style="color: #E82B27">*</span>
                        </strong><br />
                        <span class="text-remark">{{selectedPlaceOption.params.optionNote}}</span>
                      </label>
                      <input id="info_name2_text" class="form__text" type="text" v-model="attributes.info.pickupDetail" />
                      <div class="alert alert--error" v-if="error.pickupDetail">
                        <span v-if="selectedPlaceOption.params.required">{{ selectedPlaceOption.params.required }}</span>
                        <span v-else>กรุณากรอกข้อมูล</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <page-selector
                :product="product"
                v-model="attributes.page"
                v-show="false" />

              <product-cart-action
                :product="product"
                :attributes="attributes"
                :initialQuantity="1"
                :addToCartButton="false"
                :buyNowButton="false"
                :style="{margin:0}"
                ref="cartAction" />

              <div class="text-center">
                <div class="alert alert--warning">โปรดตรวจสอบข้อมูลผู้สมัครวิ่งให้ถูกต้องก่อนกดปุ่มสมัครวิ่ง</div>
                <button type="button" class="btn btn--purple btn--default" @click.prevent="confirmReward">สมัครวิ่ง/ชำระเงิน</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DonorInfo from '@/components/DonorInfo'
  import PageSelector from '@/components/PageSelector'
  import ProductCartAction from '@/components/ProductCartAction'
  import ProductDonateChoice from '@/components/ProductDonateChoice'
  import Parser from '@/parser'

  export default {
    name: 'ProductTemplateUOBRunTicket2025',

    components: {
      DonorInfo,
      PageSelector,
      ProductCartAction,
      ProductDonateChoice
    },

    props: {
      title: { type: String, default: 'บริจาค' },
      product: { type: Object, required: true }
    },

    data () {
      return {
        tshirtProductName: 'Ticket',
        priceDivider: 300,
        attributes: {
          info: {
            rewardProduct: '',
            rewardConfigChoice: '',
            rewardConfigText: '',
            pickupPoint: '',
            pickupDetail: '',
            rewardConfigSize: '',
            shippingRequired: false
          },
          page: ''
        },
        error: {
          rewardConfigSize: false,
          atLeastOneReward: false
        },
        rewards: [],
        selectedAddReward: '',
        genders: [
          { name: 'Male', value: 'M' },
          { name: 'Female', value: 'F' },
        ],
        ranges: [
          { name: '3 กิโลเมตร', value: '3' },
          { name: '5 กิโลเมตร', value: '5' },
          { name: '10 กิโลเมตร', value: '10' },
          { name: 'ขอเป็นกองเชียร์', value: 'CHEER' },
        ],
      }
    },

    computed: {
      rewardTitleText () {
        if (this.rewardCount > 0) {
          return `ลงทะเบียนสมัครวิ่ง ${this.rewardCount} คน`
        }
        return 'กรุณากรอกข้อมูลผู้ลงสมัครวิ่งและเลือกระยะทาง'
      },

      rewardCount () {
        return 3
        // return Math.floor(this.product.price / this.priceDivider)
      },

      isRewardDisabled () {
        return false
        // return this.product.price < this.priceDivider
      },

      isTakeReward () {
        return this.attributes.info.rewardProduct === this.tshirtProductName
      },

      selectedRewardCount () {
        return this.rewards.length
      },

      sizeOptions () {
        // SS:รอบอก 34 นิ้ว,S:รอบอก 36 นิ้ว,M:รอบอก 38 นิ้ว,L:รอบอก 40 นิ้ว,XL:รอบอก 42 นิ้ว,XXL:รอบอก 44 นิ้ว
        return this.product.meta.donation_tshirt_size.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      },

      // ตำแหน่ง
      LevelOptions () {
        // 1:Managing Director,2:Executive Director
        return this.product.meta.donation_level_option.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      },
      // หน่วยงาน
      FunctionOptions () {
        // 1:Personal Financial Services, 2:Project Management Office
        return this.product.meta.donation_function_option.split(',').map(row => {
          const [ text, description ] = row.split(':')
          return { text, description }
        })
      },
      // สถานที่
      PlaceOptions () {
        return Parser.uob.parsePlaceOption(this.product.meta.donation_place_option)
      },

      selectedPlaceOption () {
        return this.PlaceOptions.find((opt) => opt.name === this.attributes.info.pickupPoint)
      },
    },

    created () {
      // Force reward product.
      this.attributes.info.rewardProduct = this.tshirtProductName

      for (let i = 0; i < this.rewardCount; i++) {
        this.rewards.push({
          fullName: '',
          tel: '',
          gender: 'M',
          range: '3',
          errors: {
            fullName: null,
            tel: null,
            gender: null,
            range: null,
          },
        })
      }
    },

    methods: {
      hasPlaceOptionDetail () {
        return this.selectedPlaceOption && this.selectedPlaceOption.params && this.selectedPlaceOption.params.optionType
      },
      isPlaceOptionType (type) {
        return this.hasPlaceOptionDetail() && this.selectedPlaceOption.params.optionType.type === type
      },

      getSizeDescription (size) {
        return this.sizeOptions.find(opt => opt.text === size).description
      },

      onSelectSize (e) {
        const size = e.currentTarget.value
        if (size) {
          this.rewards.push({
            size,
            code: '',
            error: false
          })

          this.$nextTick(() => {
            this.$refs.inputCode[this.$refs.inputCode.length - 1].focus()
          })
        }
        this.selectedAddReward = ''
        this.error.rewardConfigSize = false
      },

      removeReward (index) {
        this.rewards.splice(index, 1)
      },

      validate () {
        this.error.rewardConfigChoice = false
        this.error.rewardConfigText = false
        this.error.pickupPoint = false
        this.error.pickupDetail = false
        this.error.atLeastOneReward = false

        let valid = true
        const {info} = this.attributes

        // Validate code.
        for (const reward of this.rewards) {
          const error = {
            fullName: null,
            tel: null,
            gender: null,
            range: null,
          }

          // Only validate if fullName or tel has been entered
          const hasFullName = reward.fullName && reward.fullName.trim()
          const hasTel = reward.tel && reward.tel.trim()

          if (hasFullName || hasTel) {
            if (!reward.fullName) {
              error.fullName = true
              valid = false
            }
            if (!reward.tel || !reward.tel.trim().match(/^[0-9]{10}$/)) {
              error.tel = true
              valid = false
            }
            if (!reward.gender) {
              error.gender = true
              valid = false
            }
            if (!reward.range) {
              error.range = true
              valid = false
            }
          }

          reward.errors = error
        }
        this.$set(this, 'rewards', [ ...this.rewards ])

        // Check if at least one reward item is filled
        const hasAtLeastOneReward = this.rewards.some(reward => {
          const hasFullName = reward.fullName && reward.fullName.trim()
          const hasTel = reward.tel && reward.tel.trim()
          return hasFullName || hasTel
        })
        if (!hasAtLeastOneReward) {
          this.error.atLeastOneReward = true
          valid = false
        }

        if (!info.rewardConfigChoice) {
          this.error.rewardConfigChoice = true
          valid = false
        }
        if (!info.rewardConfigText) {
          this.error.rewardConfigText = true
          valid = false
        }
        if (!info.pickupPoint) {
          this.error.pickupPoint = true
          valid = false
        }
        if (this.selectedPlaceOption && this.hasPlaceOptionDetail() && !info.pickupDetail) {
          this.error.pickupDetail = true
          valid = false
        }

        return valid
      },

      confirmReward () {
        if (!this.$refs.donateChoice.validate()) {
          return
        }

        if (!this.validate()) {
          this.$utils.scrollToFirstErrors()
          return
        }

        this.donate()
      },

      async donate () {
        const info = JSON.parse(JSON.stringify(this.attributes.info))
        this.rewards
          .filter(r => r.fullName && r.tel && r.fullName.trim() && r.tel.trim())
          .forEach((reward, i) => {
            info[`bib_${i + 1}_full_name`] = reward.fullName.trim()
            info[`bib_${i + 1}_tel`] = reward.tel.trim()
            info[`bib_${i + 1}_gender`] = reward.gender
            info[`bib_${i + 1}_range`] = reward.range
          })
        // Re-assign info back to attributes.
        this.attributes.info = info
        if (this.product.meta.receipt_item_description) {
          this.attributes.info._receiptItemDescription = this.product.meta.receipt_item_description
        }
        if (this.product.meta.receipt_item_code) {
          this.attributes.info._receiptItemCode = this.product.meta.receipt_item_code
        }

        // Clear previous cart info.
        await this.$store.dispatch('clearCart')

        // Add donation product to cart and go to checkout.
        this.$refs.cartAction.buyNow()
      },

      hasSelectedSize (text) {
        return this.selectedSize[text] > 0
      }
    },

    watch: {
      'product.price': function (amount) {
        if (!amount || amount < this.priceDivider) {
          this.attributes.info.rewardProduct = ''
        } else {
          this.attributes.info.rewardProduct = this.tshirtProductName
        }
        this.rewards.splice(this.rewardCount)
        // create the placeholder for new items
        const newItemCount = this.rewards.length
        if (newItemCount < this.rewardCount) {
          for (let i = newItemCount; i < this.rewardCount; i++) {
            this.rewards.push({
              fullName: '',
              tel: '',
              gender: 'M',
              range: '3',
              errors: {
                fullName: null,
                tel: null,
                gender: null,
                range: null,
              },
            })
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .logo-heartbeat {
    width: 100px;
  }
  .logo {
    width: 150px;
  }

  /* Fix for runner registration form - stack columns on mobile */
  .reward-item .row .d-flex.align-items-center {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .reward-item .col-sm-12.col-md-2,
  .reward-item .col-sm-12.col-md-4,
  .reward-item .col-sm-12.col-md-8 {
    width: 100%;
    margin-bottom: 0;
  }

  .reward-item .form__label {
    margin-bottom: 0;
  }
}

.product-custom-title {
  color: #005eb6;
}
  h1.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
    font-size: 2em;
    font-weight: 400;
    margin-bottom: 15px;
  }

  h3.page-title {
    color: #fff;
    text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
  }
  .block { background: #fff; }
  .btn--default {
    margin: 20px auto 10px;
    background-color: #E32828;
    border-color: #E32828
  }

  .custom-select {
    border: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -ms-appearance: none;

    font-family: Prompt, Arial, sans-serif;

    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" fill="%23000000"><polygon points="0,0 100,0 50,75"/></svg>');
    background-size: 12px;
    background-repeat: no-repeat;
    background-position: calc(100% - 10px) calc(50% + 2px);
    padding-right: 20px;
    line-height: 1.5;
  }

  .select-add {
    background-color: #F0F0F0;
    border: 2px dashed #B5B5B5;
    border-radius: 4px;
    width: 100%;
    padding: 16px 20px;
  }

  .select-change {
    width: 70px;
  }

  .reward-item {
    border: 2px solid #005eb65c;
    border-radius: 4px;
    margin-bottom: 10px;

    &.reward-item-error {
      border-color: red;
    }

    & > * {
      padding: 12px 16px;

      &:first-child {
        border-bottom: 1px solid #005eb65c;
      }
    }

    select {
      margin-right: 12px;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 5px 10px;

    }

    .size-description {
      color: #999;
      flex-grow: 1;
    }

    .code-input {
      width: 125px;
      background-color: #F3E7AD;
      outline: none;
      border: 2px solid #F3E7AD;
      border-radius: 4px;
      padding: 5px 10px;
      margin-left: 12px;
      font-family: Prompt, Arial, sans-serif;

      &.error {
        border-color: red;
      }
    }
  }

  .reward-count {
    background-color: #ccc;
    border-radius: 8px;
    padding: 4px 6px;
    display: inline-block;
    line-height: 1;
  }

  .slide-down-wrapper {
    margin-top: 15px;
  }

  .current-thumbnail-wrapper {
    cursor: zoom-in;
  }

  .thumbnail-wrapper {
    border: 1px solid transparent;
    cursor: pointer;

    &.selected {
      border-color: orange;
    }
  }

  .btn-remove {
    background: #F82E2E;
    border-radius: 3px;
    color: #fff;
    border: none;
    font-family: Prompt, Arial, sans-serif;
    line-height: 1.5;
    cursor: pointer;
  }

  .size-choice {
    cursor: pointer;

    &.only-one {
      .number-field {
        display: none;
      }
    }

    &.active {
      border: 1px solid orange;
    }
  }

  .bib-section-title {
    flex-grow: 1;
    font-weight: 500;
  }

  @media (max-width: 767px) {
    .runner-form-row {
      flex-direction: column;
      align-items: flex-start !important;
    }

    .runner-form-row > div {
      width: 100%;
      // margin-bottom: 8px;
    }

    .form__label {
      // margin-bottom: 5px;
    }

    /* Make the form fields take full width on mobile */
    .col-sm-12 input.form__text,
    .col-sm-12 select.form__select {
      width: 100%;
    }

    /* Add some spacing between form sections */
    .form__item--block {
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// uob-run-ticket-2025.vue?72dabb7c